/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Support_ResultInputs */

const en_wb_support_result = /** @type {(inputs: Wb_Support_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your team checks the answer. The system takes care of the lookup and the follow-through.`)
};

const lv_wb_support_result = /** @type {(inputs: Wb_Support_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu komanda pārbauda atbildi. Sistēma parūpējas par datu atrašanu un turpmākajām darbībām.`)
};

/**
* | output |
* | --- |
* | "Your team checks the answer. The system takes care of the lookup and the follow-through." |
*
* @param {Wb_Support_ResultInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_support_result = /** @type {((inputs?: Wb_Support_ResultInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Support_ResultInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_support_result(inputs)
	return en_wb_support_result(inputs)
});